import {
  AuthGuard,
  GENERAL_CONSTANTS,
  HowdenMainLayoutComponent,
  HowdenWithoutMenuLayoutComponent,
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  NotAuthorizedComponent
} from '@howdeniberia/core-front';
import { UserRole } from './core/enums';
import { MapSearchComponent } from './features/management/map-search/pages/map-search/map-search.component';
import { RiskRatingSearchComponent } from './features/management/risk-rating-search/pages/risk-rating-search/risk-rating-search.component';
import { CookieDeleteComponent } from './features/homepage/pages/cookie-delete/cookie-delete.component';
import { HomeComponent } from './features/homepage/pages/home/home.component';
import { RisksEvaluationComponent } from './features/risk-map-evaluation/pages/risks-evaluation/risks-evaluation.component';
import { InitialComponent } from './features/initial/initial/initial.component';
import { Routes } from '@angular/router';

export const AppRoutes = [
  //Componente para decidir a qué url redirecciona (cliente o gestor)
  {
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    path: '',
    pathMatch: 'full',
    component: InitialComponent,
    data: {
      //Accesible para roles del mapa de riesgos ( y los usuarios superadmin tb tendrán acceso porque en el core así se determina)
      roles: [UserRole.Admin, UserRole.Manager, UserRole.Basic]
     }
  },
  //Menús para usuarios gestor bajo la ruta management (roles admin o manager)
  {
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    path: '',
    component: HowdenMainLayoutComponent,
    data: {
      isLayout: true,
      //Sólo accesible para administradores y gestores del mapa de riesgos ( y los usuarios superadmin tb tendrán acceso porque en el core así se determina)
      roles: [UserRole.Admin, UserRole.Manager]
    },
    children: [
      {
        path: 'management/home',
        component: HomeComponent,
        data: {
          icon: 'scatter_plot',
          linkText: $localize`:@@app.route.home.carousel:Inicio`
        }
      },
      {
        path: 'management/cookie-delete',
        component: CookieDeleteComponent,
        data: {}
      },
      {
        path: 'management/risks-evaluation',
        component: RisksEvaluationComponent,
        title: $localize`:@@app.route.risks-evaluation: Evaluación Riesgos`,
        data: {}
      },
      {
        path: 'management/risks-evaluation/:id',
        component: RisksEvaluationComponent,
        title: $localize`:@@app.route.risks-evaluation: Evaluación Riesgos`,
        data: {}
      },
      {
        path: 'management/map-search',
        component: MapSearchComponent,
        title: $localize`:@@app.route.management.map-search: Mapas Realizados`,
        data: {
          icon: 'description',
          linkText: $localize`:@@app.route.management.map-search.menu: Informes`
        }
      },
      {
        path: 'management/risk-rating-search',
        component: RiskRatingSearchComponent,
        title: $localize`:@@app.route.management.risk-rating-search: Valoraciones Riesgos`,
        data: {
          icon: 'task',
          linkText: $localize`:@@app.route.management.risk-rating-search.menu: Valoraciones`
        }
      }
    ]
  },
  //Ruta para los usuarios cliente, que no tienen líneas de menú
  {
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    path: '',
    component: HowdenWithoutMenuLayoutComponent,
    data: {
      isLayout: true,
      //Accesible para clientes del mapa de riesgos ( y los usuarios superadmin tb tendrán acceso porque en el core así se determina)
      roles: [UserRole.Basic]
    },
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: {}
      },
      {
        path: 'cookie-delete',
        component: CookieDeleteComponent,
        data: {}
      },
      {
        path: 'risks-evaluation',
        component: RisksEvaluationComponent,
        title: $localize`:@@app.route.risks-evaluation: Evaluación Riesgos`,
        data: {}
      }
    ]
  },
  {
    path: GENERAL_CONSTANTS.NotAuthorizedUrl,
    title: $localize`:@@app.route.notauthorized: No autorizado`,
    component: NotAuthorizedComponent
  },
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  { path: '**', redirectTo: '404' }
] as Routes;
